module.exports = __webpack_public_path__ + "img/TODOLIST.9b4ad6c3.png";